import { constants } from './config';

const initialState = {
  loading: false,
  done: false,
  error: false,
  info: null,
};

export const serviceCompanyOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.POST_SERVICE_COMPANY_ORDER:
      return {
        ...state,
        loading: true,
        error: false,
        done: false,
      };

    case constants.POST_SERVICE_COMPANY_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        done: true,
        error: false,
        info: action.payload,
      };

    case constants.POST_SERVICE_COMPANY_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        done: false,
        error: action.payload,
      };

    case constants.RESET_SERVICE_COMPANY_ORDER:
      return initialState;

    default:
      return state;
  }
};
